import * as types from "../actions/actionTypes";

const initialState = {
  customers: [],
  customer: null,
};

const customer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_CUSTOMER_RESPONSE: return { ...state, customers: action.payload };
    case types.GET_CUSTOMER_RESPONSE: return { ...state, customer: action.payload };
    case types.CREATE_CUSTOMER: return { ...state, customer: null };
    case types.DELETE_CUSTOMER: return { ...state, customer: null };
    case types.UPDATE_CUSTOMER: return { ...state, customer: null };
    case types.CREATE_CUSTOMER: return { ...state, customer: null };
    default:
      return state;
  }
};

export default customer;
